import React from "react";
import validate from './validateInfo';
import useForm from './useForm';
import './SignUpForm.css';

const SignUpForm = ({ submitForm }) => {
  const { handleChange, handleSubmit, values, errors } = useForm(
    submitForm,
    validate
  );

  return(
    <div className="form-container">
      <img src="./images/L2.jpg" alt="Dog with Owner" className="img"/>
      <div className="form-content-right">
        <form onSubmit={handleSubmit} className='form' noValidate>
          <h1 className="title">
            Sign Up Today
          </h1>
          <span className='form-input-login'>
            Already have an account? <a href='/login'>Log-in here</a>
          </span>
          <div className='form-inputs'>
            <label className='form-label'>Username</label>
            <input
              className='form-input'
              type='text'
              name='username'
              placeholder='Enter your username'
              value={values.username}
              onChange={handleChange}
            />
            {errors.username && <p>{errors.username}</p>}
          </div>
          <div className='form-inputs'>
            <label className='form-label'>Email</label>
            <input
              className='form-input'
              type='email'
              name='email'
              placeholder='Enter your email'
              value={values.email}
              onChange={handleChange}
            />
            {errors.email && <p>{errors.email}</p>}
          </div>
          <div className='form-inputs'>
            <label className='form-label'>Password</label>
            <input
              className='form-input'
              type='password'
              name='password'
              placeholder='Enter your password'
              value={values.password}
              onChange={handleChange}
            />
            {errors.password && <p>{errors.password}</p>}
          </div>
          <div className='form-inputs'>
            <label className='form-label'>Confirm Password</label>
            <input
              className='form-input'
              type='password'
              name='password2'
              placeholder='Confirm your password'
              value={values.password2}
              onChange={handleChange}
            />
            {errors.password2 && <p>{errors.password2}</p>}
          </div>
          <div className='form-inputs'>
            <label className='form-label'>Account Type</label>
            <select
              className='form-input'
              type='account'
              name='account'
              required
              value={values.account}
              onChange={handleChange}
            >
              <option value="select">--Select--</option>
              <option value="Adopter">Adopter</option>
              <option value="Shelter">Shelter</option>
          </select>
            {errors.account && <p>{errors.account}</p>}
          </div>
          <button className='form-input-btn' type='submit'>
            Sign up
          </button>
          <span className='form-input-login'>
            By continuing, you agree to accept our Privacy Policy and Terms of Service.
          </span>
        </form>
      </div>
    </div>
  )
}
export default SignUpForm;